module.exports = __webpack_public_path__ + "static/media/upload-success-confirm@2x.c81ffb95.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/upload-success-confirm@2x.png
// module id = 920
// module chunks = 0